package com.eladfinish.bible.contest.ui.common

import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.text.font.FontFamily
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.keter_medium
import com.eladfinish.bible.contest.ui.components.ParchmentBackground
import com.eladfinish.bible.contest.withFontFamily
import dev.icerock.moko.resources.compose.fontFamilyResource

data class AppThemeState(
    val fontFamily: FontFamily,
)

// TODO: should be used only once in MainActivity
@Composable
fun AppTheme(themeState: AppThemeState, content: @Composable () -> Unit) {
    val defaultTypography = MaterialTheme.typography
    val fontFamily = themeState.fontFamily
    val typography = defaultTypography.withFontFamily(fontFamily = fontFamily)
    MaterialTheme(
        colorScheme = MaterialTheme.colorScheme,
        typography = typography,
        shapes = MaterialTheme.shapes,
        content = content
    )
}

@Composable
fun PreviewTheme(content: @Composable () -> Unit) {
    AppTheme(themeState = AppThemeState(fontFamily = fontFamilyResource(fontResource = SharedRes.fonts.keter_medium))) {
        ParchmentBackground {
            RtlContainer {
                content()
            }
        }
    }
}
